import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { AlertService } from '../app/_alert';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  baseUrl: String = 'https://prod.gcportal.com/api/gc-portal/';
  voucherSuccessFlag: boolean;
  config: any;

  private localUserObj: any = JSON.parse(localStorage.getItem("userObj"));
  private userObj = new BehaviorSubject<any>({ loggedIn: false });
  public userObjObserveable = this.userObj.asObservable();
  public options = {
    autoClose: true,
    keepAfterRouteChange: true
  }

  constructor(
    private router: Router,
    private http: HttpClient,
    public alertService: AlertService
  ) { };

  public updateUserDetail(reqObj: any) {
    this.userObj.next(reqObj);
  };

  setBaseURL() {
    this.baseUrl = environment.urls.baseUrl;
  };

  getCaptchaURL() {
    return environment.urls.captchaUrl;
  };

  public customPostApiCall(customdata: any, apiData: any) {
    customdata = customdata || {};
    let httpApiObj = { "apiType": apiData.apiType, "apiCallFrom": "customPostApiCall" };
    let finalApi = `${this.baseUrl}` + apiData.apiExt;
    this.localUserObj = JSON.parse(localStorage.getItem("userObj"));
    if (this.localUserObj && this.localUserObj.token) {
      this.config = new HttpHeaders().set('Authorization', 'Bearer ' + this.localUserObj.token);
    }
    return this.custmPostRespCall(finalApi, customdata, httpApiObj, { headers: this.config });
  };

  public custmPostRespCall(finalApi, customdata, httpApiObj, headers) {
    let ref = this;
    let promise = new Promise((resolve, reject) => {
      this.http[httpApiObj.apiType](finalApi, customdata, headers).subscribe((res: any) => {
        if (res && res.message) {
          this.alertService.success(res.message, this.options);
          resolve(res);
        } else if (res && res.message && res.status == "failure") {
          this.alertService.error(res.message, this.options);
          resolve(res);
        } else if (!res) {
          resolve('');
        } else {
          resolve(res);
        }
      },
        (error) => {
          if (error.status == 401 && window.location.pathname !== '/login') {
            this.logOut();
          } else if (error.status != 200) {
            reject(error);
          } else {
            reject(error);
          }
        })
    })
    return promise;
  };

  public customGetApiCall(customdata: any, apiData: any) {
    customdata = customdata || {};
    let httpApiObj = { "apiType": apiData.apiType, "apiCallFrom": "customPostApiCall" };
    let finalApi = `${this.baseUrl}` + apiData.apiExt;
    this.localUserObj = JSON.parse(localStorage.getItem("userObj"));
    if (this.localUserObj && this.localUserObj.token) {
      this.config = new HttpHeaders().set('Authorization', 'Bearer ' + this.localUserObj.token);
    }
    return this.custmGetRespCall(finalApi, customdata, httpApiObj, { headers: this.config });
  };

  public custmGetRespCall(finalApi, customdata, httpApiObj, headers) {
    let ref = this;
    let promise = new Promise((resolve, reject) => {
      this.http[httpApiObj.apiType](finalApi, headers, customdata).subscribe((res: any) => {
        if (res && res.message) {
          this.alertService.success(res.message, this.options);
          resolve(res);
        } else if (res && res.message && res.status == "failure") {
          this.alertService.error(res.message, this.options);
          resolve(res);
        } else if (!res) {
          resolve('');
        } else {
          resolve(res);
        }
      },
        (error) => {
          if (error.status == 401 && window.location.pathname !== '/login') {
            localStorage.clear();
            this.localUserObj = {};
            this.updateUserDetail({ "loggedIn": false });
            this.router.navigate(['/login']);
            this.logOut();
          } else if (error.status != 200) {
            reject(error);
          } else {
            reject(error);
          }
        })
    })
    return promise;
  };

  logOut() {
    const apiData = {
      "apiType": "get",
      "apiExt": "logout",
    };
    this.customGetApiCall({}, apiData).then((res: any) => {
      localStorage.clear();
      this.localUserObj = {};
      this.updateUserDetail({ "loggedIn": false });
      this.router.navigate(['/login']);
    },
      (error) => {
        localStorage.clear();
        this.localUserObj = {};
        this.updateUserDetail({ "loggedIn": false });
        if (error.status == 401) {
          error.error.detail === 'Full authentication is required to access this resource' ?
            this.alertService.error(error.error.detail, this.options) :
            this.alertService.error("Login session expired, please re-login!", this.options);
        }
        this.router.navigate(['/login']);
      });
  }

  public setVoucherSuccessFlag(value: boolean) {
    this.voucherSuccessFlag = value;
  }
}
